// extracted by mini-css-extract-plugin
module.exports = {"alert":"alert___E5gO-","message":"message___VXpJo","report":"report___OL-N6"};